import { Grid2 } from '@aibees/shared/components';
import { styled } from '@mui/material/styles';

export const Wrapper = styled(Grid2)`
  /* width: 50%; */
`;
